import React from 'react';

import {PageMenu} from '../components/PageMenu';

export const TermsPage: React.FC = () => (
  <main>
    <PageMenu active="/terms" />

    <h1 className="mb-16 mt-20 text-center text-3xl font-light text-neutral-700">
      利用規約
    </h1>
    <div className="mt-6 pb-20 text-left text-sm font-light text-neutral-900 [&_section>p:not(:last-child)]:mb-3.5">
      <div className="mx-auto max-w-[840px] px-4">
        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            総則
          </h4>
          <p>
            「ACTION CENTER
            MIHARA」（以下「本サイト」といいます。）のサービス（以下「本サービス」といいます。）は、株式会社エムセック（以下「当社」といいます。）が提供するプラットフォームを利用して運営されています。本サービスは、以下のサービス利用規約（以下「本規約」といいます。）及びこれに付随する各種個別規定及びガイドライン等（以下、本規約、個別規定及びガイドライン等を総称して「本規約等」といいます。）に基づいて提供されます。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 1 条（規約の適用）
          </h4>
          <p>
            本規約は、株式会社エムセックが運営する本サイトのすべてにおいて、会員と当社との間に適用されます。本規約は各サービスにおける個別規定、ガイドライン等の諸規程と共に重畳的に適用され、個別規定、ガイドライン等の諸規程は、本規約の一部を構成します。会員は、本サービスを利用することにより、本規約等及びプライバシーポリシーの全ての項目に同意したこととみなされます。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 2 条（用語の定義）
          </h4>
          <p>
            1.「会員」とは、本規約等に同意の上本サイトに会員登録をした個人および団体をいいます。
          </p>
          <p>
            2.「主催者」とは、本サービスを利用してイベントあるいはコミュニティを主催する者をいいます。
          </p>
          <p>
            3.「参加者」とは、会員であって本サービスを利用してイベントあるいはコミュニティに参加する者をいいます。
          </p>
          <p>
            4.「イベント」とは、本サイト内で作成されたイベントのことをいいます。
          </p>
          <p>
            5.「チケット」とは、本サイトで作成されたイベントに参加することを可能にする電子媒体、もしくはそれを印刷した媒体をいいます。
          </p>
          <p>
            6.「コミュニティ」とは、本サイトで作成されたコミュニティのことをいいます。
          </p>
          <p>
            7.「有料チケット」とは、チケットのうち、主催者が本サイトのサービスを利用して発行する有料のチケットをいいます。
          </p>
          <p>
            8.「無料チケット」とは、チケットのうち、主催者が本サイトのサービスを利用して発行する無料のチケットをいいます。
          </p>
          <p>
            9.「取引」とは、会員が本サイトを通じて行う有料チケットの購入、無料チケットの取得、及び会費の利用をいいます。
          </p>
          <p>
            10.「個別規定」とは、参加者向け個別規定（以下「参加者規定」といいます。）、主催者向け個別規定（以下「主催者規定」といいます。）をいいます。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 3 条（当社の役割）
          </h4>
          <p>
            当社は、第三者である主催者と参加者が取引を成立させるため、代金を決済する場を提供します。当社は主催者と参加者との間の実際の取引には関与するものではありません。従って、取引成立時には、主催者と参加者間に契約が成立することになります。また、主催者と会員との間又は会員相互の間で紛争が生じた場合(イベントが中止された場合の返金を含みます)でも、当該紛争については当該会員間で解決するものとし、当社は一切の責任を負わないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 4 条（会員資格及び会員登録手続）
          </h4>
          <p>
            本規約等及びプライバシーポリシーに同意のうえ所定の入会申込みをされた個人及び団体は、所定の登録手続完了後に会員としての資格を有します。会員登録手続は、会員となる本人（会員となるものが団体の場合には、当該団体から会員登録手続きについて適法に授権された者）が行ってください。代理による登録は一切認められません。また、13歳未満の方は本サイトに会員登録することはできません。20歳未満の方は、必ず保護者の方の同意を得てから、入会申し込みを行ってください。なお、13歳以上20歳未満の方による入会申し込みを受けた場合、保護者の方の同意を得たものとして取り扱うこととし、また、当社は、過去に会員資格が取り消された方や当社が相応しくないと判断した方の会員登録をお断りする場合があります。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 5 条（会員情報の入力）
          </h4>
          <p>会員登録手続の際には、必要事項を正確に入力してください。</p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 6 条（ユーザー名及びパスワードの管理）
          </h4>
          <p>
            ユーザー名及びパスワードは、他人に知られることがないよう定期的に変更する等、会員本人が責任をもって管理してください。入力されたユーザー名及びパスワードが登録されたものと一致することを所定の方法により確認した場合、当社は、会員による利用があったものとみなし、それらが盗用、不正使用その他の事情により会員以外の者に利用されている場合であっても、それにより生じた損害について当社は一切責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 7 条（登録情報の変更）
          </h4>
          <p>
            登録した情報に変更が生じた場合は、速やかに変更をお願いします。登録内容の変更がなされなかったことにより生じた損害について、当社は、一切責任を負いません。また、変更がなされた場合でも、変更前にすでに成立した取引は、変更前の情報に基づいて行われます。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 8 条（会員の退会）
          </h4>
          <p>
            会員が主催者で、当該会員が本サービス上で既にイベントを公開しており、かつ、当該イベントが終了していない場合を除き、会員が退会を希望する場合、当該会員は、本サービス上で、すみやかに退会の申請を行うこととします。退会を希望する会員は、所定の退会手続きが完了した後に、退会となります。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 9 条（環境設定）
          </h4>
          <p>
            1.本サービスを会員が利用するために必要なあらゆる機器、設備、ソフトウェア及び通信手段は、会員自身の責任と費用において適切に準備又は設置し、操作するものとします。
          </p>
          <p>
            2.当社は会員の本サイト及び本サービスに対するアクセス環境について一切関与せず、それに関する一切の責任を負わないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 10 条（当社の免責）
          </h4>
          <p>
            1.会員が本サービスを利用するにあたって、通信回線やコンピュータなどの障害によるシステムの中断、遅滞、中止、データの消失、もしくはデータへの不正アクセスにより生じた損害その他本サービスに関して会員に生じた損害について、当社は一切責任を負わないものとします。但し、当該損害の発生について、当社に故意又は重過失が存在する場合はこの限りではないものとします。
          </p>
          <p>
            2.当社は、当社のウェブページ、サーバ、ドメインなどから送られるメールコンテンツに、コンピューターウィルスその他の会員のコンピュータ、デバイス、端末に対して有害な影響を生じさせるプログラムが含まれていないことを保証するものではなく、当社のメールコンテンツにそのようなプログラムが含まれていたことに起因して会員に損害が生じた場合であっても、当社は一切責任を負わないものとします。
          </p>
          <p>
            3.当社は、会員に対し、適宜情報提供やアドバイスを行うことがありますが、それにより責任を負うものではありません。
          </p>
          <p>
            4.会員が本規約等に違反したことによって生じた損害については、当社は一切責任を負いません。
          </p>
          <p>
            5.本サイト及び本サービスにて提供されているイベントの内容に関して、当社は一切の責任を負いません。
          </p>
          <p>
            6.本サイト及び本サービスにて提供される全ての情報（本サービスに関連して送信される電子メール等により提供される情報等、及び本サイト上に表示される、第三者が管理・運営するリンクサイト内に含まれる一切の情報等を含みます。）に関する、有用性、適合性、完全性、正確性、安全性、合法性、最新性等について、当社は一切責任を負いません。
          </p>
          <p>
            7.当社は、本サービスを提供するにあたって、本サービスについて不具合、エラー、障害その他の問題が生じないことを保証するものではありません。
          </p>
          <p>
            8.本サービスの利用又は利用不能により生じる一切の損害（直接又は間接を問わず、また金銭的損害か精神的損害かを問いません。）について当社は一切の責任を負わないものとします。但し、当該損害の発生について、当社に故意又は重過失が存在する場合はこの限りでないものとします。
          </p>
          <p>
            9.本サービスに関して会員間又は会員及び第三者との間で発生した一切のトラブル及び紛争については、会員の責任において処理及び解決するものとし、当社はかかる事項について一切責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 11 条（禁止事項）
          </h4>
          <p>
            会員は、本サービスを利用するにあたり、以下の各行為をしてはならないものとします。
          </p>
          <p>
            1.法令、ガイドライン、指針、本規約等、本サイトの利用上の注意その他本サービスに関して適用のある規約等に違反すること
          </p>
          <p>
            2.当社にサービスを提供する会員及び第三者の権利、名誉等をを損ねること
          </p>
          <p>
            3.青少年の心身に悪影響を及ぼす恐れがある行為、その他公序良俗に反する行為
          </p>
          <p>
            4.有害なコンピュータープログラム、メール等を送信又は書き込むこと
          </p>
          <p>
            5.ユーザー名及びパスワードを第三者に貸与もしくは譲渡すること、又はこれらを第三者と共用すること
          </p>
          <p>
            6.当社から事前に許可を得ることなく、提供情報の一部又は全部を複製、複写、送信、転載、配布、頒布等の方法により、第三者に提供すること
          </p>
          <p>7.選挙期間中であるか否かを問わず、選挙運動又はこれに類する行為</p>
          <p>8.当社又は第三者の著作権、商標権等の知的財産権を侵害する行為</p>
          <p>
            9.前項に定めるほか、当社又は第三者の財産権、プライバシー権、肖像権その他の権利を侵害する行為
          </p>
          <p>10.公序良俗に違反する行為</p>
          <p>
            11.自己又は他人の名称、住所、電話番号、電子メールアドレス等について、意図的に虚偽の情報を登録する行為
          </p>
          <p>12.イベント情報等に虚偽又は不正確な内容を書き込む行為</p>
          <p>
            13.本サービスの機能や情報の正確性に関する問い合わせ又はクレームを投稿する行為
          </p>
          <p>14.当社が意図する本サービスの目的以外に本サービスを利用する行為</p>
          <p>15.当社又は第三者に対する迷惑行為</p>
          <p>
            16.詐欺、規制薬物の濫用、売買春、マネーロンダリング等の犯罪に結びつく、又は結びつくおそれのある行為
          </p>
          <p>
            17.サイト外取引についての優遇措置の表示その他の方法により顧客を本サービス外の取引に誘引する行為
          </p>
          <p>18.その他当社が不適切と判断する行為</p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 12 条（会員情報の取り扱い）
          </h4>
          <p>
            会員情報につきましては、当社のプライバシーポリシーに従い当社が管理します。当社は会員情報を会員への本サービス提供、本サービス内容の向上、本サービスの利用促進（ダイレクトメールを含みます。）、及び本サービスの健全かつ円滑な運営の確保を図る目的のために、当社において利用することができるものとします。対象となる会員情報は、会員登録の際に会員が記入したすべての情報とします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 13 条（特定会員の利用停止・会員資格取消）
          </h4>
          <p>
            当社は、特定の会員が次のいずれかに該当すると判断した場合には、事前に通知することなく当該会員によるサービスの利用停止、当該会員のユーザー名及びパスワードの変更、又は当該会員の会員資格の取消しを行えるものとします。これにより会員に何らかの損害が生じたとしても、当社は一切責任を負わないものとします。
          </p>

          <p>1.法令及び本規約等に違反する行為があった場合</p>
          <p>2.当該会員に本サービス利用に関して不正行為があった場合</p>
          <p>
            3.一定回数以上のパスワードの入力ミスがあるなどセキュリティ保護に問題があった場合
          </p>
          <p>4.他の会員のユーザー名及びパスワードを利用した場合</p>
          <p>
            5.他の会員のコンテンツを事前同意なく出版及び放送などに提供した場合
          </p>
          <p>6.当該会員の登録情報に虚偽の事実があることが判明した場合</p>
          <p>7.その他当社が適当と判断した場合</p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 14 条（サービスの中断・変更・廃止）
          </h4>
          <p>
            当社は、その判断により本サービスの全部又は一部を中断、変更又は廃止できるものとします。本サービスの一時的な停止若しくは終了又は本サービスのサービス内容等の変更により、会員又は第三者に損害が発生した場合でも、当社は一切の責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 15 条（再委託）
          </h4>
          <p>
            当社は本規約等に定める自己の業務の全部又は一部を、第三者に再委託することができるものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 16 条（個人情報の取扱い）
          </h4>
          <p>
            当社は本規約等に定める自己の業務の全部又は一部を、第三者に再委託することができるものとします。
          </p>

          <p>
            1.当社は、別途掲示する「プライバシーポリシー」に基づき会員の個人情報を取扱うものとし、会員は本条項に同意のうえ、本サービスをご利用するものとします。
          </p>
          <p>
            2.会員は、以下の各号のいずれかに該当する場合に、当社が当該各号に定める者に会員の個人情報を提供することにあらかじめ同意するものとし、かかる提供が行われた場合には、これに対し異議を述べないものとします。
          </p>
          <p>
            (1).会員が希望する情報やサービスを提供するために第三者に対し個人情報の開示が必要と認められる場合（当該第三者）
          </p>
          <p>
            (2).本サイトを通じて当社が取得した会員の氏名、電子メールアドレスを、主催者が必要とし、当社がこれを認めた場合（当該主催者）
          </p>
          <p>
            (3).裁判所や警察等の公的機関から法律に基づく正式な照会を受けた場合（当該公的機関）
          </p>
          <p>
            (4).本サイトのサイト上での会員の行為が利用規約やガイドラインなどに反し、本サイトの権利、財産やサービス等を保護するため必要と認められる場合（当社が必要と認める第三者）
          </p>
          <p>
            (5).会員、公衆の生命・健康・財産などの重大な利益保護のため個人情報の開示が必要な場合（重大な利益を保護するために必要と認められる第三者）
          </p>
          <p>
            (6).代金の決済、出金手続き等において金融機関に照会が必要な場合{'　'}
            （当該金融機関）
          </p>
          <p>
            (7).法令により開示または提供義務が定められている場合（法令により提供が義務付けられている者）
          </p>
          <p>
            (8).当社が子会社または当社の事業部門を売却する場合（当該売却の相手方）
          </p>
          <p>
            (9).当社との間で共同開発契約、事業提携契約その他当社のサービスに関して協業することを内容とする契約を締結した第三者
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 17 条（広告掲載）
          </h4>
          <p>
            当社は、本サイトに適切と判断される広告を掲載することができます。本サイトに掲載されている広告によって、会員等及び第三者に損害が生じた場合であっても、当社は一切責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 18 条（本規約等の改定）
          </h4>
          <p>
            当社は、本規約等を任意に改定できるものとし、本規約等を補充する規約を定めることができるものとします。本規約等の改定又は補充は、その内容を当社所定のサイトに掲示したときにその効力を生じるものとします。この場合、会員は改定後の本規約等及び補充された本規約等に従うものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 19 条（準拠法、合意管轄）
          </h4>
          <p>
            本規約の準拠法は日本法とし、本規約に起因し又は関連する一切の紛争については、広島地方裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
        </section>

        <hr />

        <section className="mb-10">
          <h2 className="mb-4 text-base font-semibold text-neutral-900">
            参加者向け個別規定
          </h2>
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 1 条（サービスの利用申し込み）
          </h4>
          <p>
            1.参加者規定は、当社が別途規定する本規約に付随して、参加者が無料チケットを取得し、又は有料チケットを購入するにあたり、会員と当社との本サービスの利用及び運営等にかかる一切の事項に適用されるものとし、会員は参加者規定を確認及び承諾の上、本サービスを利用するものとします。当社は、参加者が無料チケットを取得し、又は有料チケットを購入した時点で、参加者規定の全ての記載内容に同意したものとみなします。参加者規定に別途定義される用語を除き、参加者規定において用いられる用語は、本規約において定義される用語と同一の意味を有するものとします。
          </p>
          <p>
            2.当社は、ユーザーの承諾を得ることなく参加者規定を変更することができるものとします。変更後の参加者規定は、当社が別途定める場合を除いて、本サイト上で表示された時点より効力を生じるものとし、ユーザーが、参加者規定の変更の効力が生じた後に本サービスを利用した場合には、変更後の参加者規定の全ての記載内容に同意したものとみなされます。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 2 条（チケットの販売の価格）
          </h4>
          <p>
            本サイトでは、主催者がその主催するイベントに係るチケットを作成及び販売しています。イベント内容並びにチケットの販売枚数及び販売価格は主催者が決定します。なお、本サイトで表示される有料チケットの販売額は税込価格となります。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 3 条（チケットの発行）
          </h4>
          <p>
            チケットの購入を希望する場合は、当社が定める利用規約及びプライバシーポリシーを予め確認及び承諾の上、本サービス所定の方法で申し込み手続きを行うものとし、チケットの申し込み手続き完了後、当社から注文完了メールが送信された段階で取引が成立し、当該チケットが有料チケットである場合には、その時点で、当該チケットに係るイベントの主催者及び当該チケットの申し込みを行った者との間で、当該チケットに係る売買契約が成立したものとみなします。なお、チケットは本サイト上の所定のページ上に電子的に表示される、もしくは電子メールにて表示されます。当社は、会員が会員の責めに帰すべき事由（チケットの申し込み手続き時に送信された情報の誤りを含みます。）によりチケットの受取が遅延すること、又は当該遅延によって発生する損害等について、一切の責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 4 条（イベントの問い合わせ）
          </h4>
          <p>
            イベント内容に関する問い合わせは参加者が主催者に対して直接行うものとし、当社はこれに関与しないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 5 条（チケットの返品・キャンセル）
          </h4>
          <p>
            1.商品の性質上、原則、参加者によって購入又は取得されたチケットの商品の返品及びキャンセルをすることはできません。ただし、以下のいずれかに該当する場合のみ、返品及びキャンセルをすることができます。
          </p>
          <p>
            ・イベント開催日時までに参加者（注文者）が主催者側へ返品及びキャンセルの依頼を行い、主催者側がこれを承諾した場合
          </p>
          <p>
            但し、銀行振込の場合、および、クレジットカード払いにて支払日から50日以上経過している場合には、チケットを購入した参加者は、当社に対し、返金手数料として、返品及びキャンセルされたチケットに係る注文1件につき500円の手数料を支払うものとします。
          </p>
          <p>
            2.第1項の規定にかかわらず、以下の事由に該当する場合には、チケットを購入した参加者は、購入したチケットをキャンセルし、チケット代金全額の返金を受けられるものとします。この場合において、参加者は、前項各号のいずれかに該当する場合であっても、返金手数料を負担することはありません。
          </p>
          <p>
            ・主催者の事情によりイベントが中止となり、主催者が当社所定の方法でイベントのキャンセル手続きを行った場合
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 6 条（イベント中止時の責任と払戻し）
          </h4>
          <p>
            主催者の事情によりイベントが中止された場合は、当社は、当該中止を告知することを含め一切の責任を負いません。
            主催者の事情によりイベントが中止となり、主催者が当社所定の方法でイベントのキャンセル手続きを行った場合は、当社は、購入した有料チケット代金の払い戻しを、当社所定の方法でおこないます。イベントの中止や不開催によりチケット代金の払戻しを行う場合、クレジットカード決済の場合は各クレジットカード会社を通して、銀行振込の場合は銀行を通して払い戻しをいたします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 7 条（転売の禁止）
          </h4>
          <p>
            購入又は取得されたチケットは、第三者に対して転売することができず、また、転売を目的として第三者に提供できません。これらに違反してチケットが第三者に転売又は提供されたことが判明した場合、当該チケットを無効とし、当該チケットに係る代金の返金及びイベントへの入場を認めない場合があります。また、当社の判断により、当該チケットの購入又は取得に用いられたアカウントの利用を停止する場合があります。当社は本サイト以外のサイト、チケットショップ、ダフ屋等から本サイトで購入又は取得できるチケットを入手した場合に生じた問題については、一切の責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 8 条（参加者特典の配布）
          </h4>
          <p>
            当社は、参加者に対し、当社や第三者の企業及び店舗等が提供する特典及び広告（以下、「参加者特典」といいます。）を配信及び掲載することがあります。参加者特典に関しては、以下に定める事項が適用されるものとします。
          </p>
          <p>
            1.参加者特典は、参加者に対する電子メール及び本サイト上に配信及び掲載されます。
          </p>
          <p>
            2.参加者特典は、参加者が自己の判断で閲覧及び利用をするものとします。
          </p>
          <p>
            3.参加者特典の閲覧及び利用をしたことにより、参加者又は第三者に損害が発生した場合でも、当社は一切の責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 9 条（会費・支援金サービス）
          </h4>
          <p>
            本サービスでは、主催者がイベント開催の有無に関わらず、コミュニティの形成と発展を目的として参加会員より月額あるいは年額の会費、または活動継続を目的とした支援金を募ることができます。これらの会費あるいは支援金は当社が当該手数料を差し引いた上で主催者へ送金いたします。会費・支援金サービスに関しては、以下に定める事項が適用されるものとします。
          </p>
          <p>
            1.会費・支援金の額、課金回数、返金、使用目的などの方針・取り決めは各主催者が判断し、当社はかかる事項に関して一切責任を負わないものとします。
          </p>
          <p>
            2.会費・支援金の支払いへの見返りとして主催者より提示されたサービスの内容に関して当社は一切責任を負わないものとします。かかる事項に関するお問い合わせは主催者へ直接ご連絡ください。
          </p>
          <p>
            3.課金対象となるコミュニティ活動内容、表記、提供サービス内容、規約に変更があった場合においても、変更内容の通知の義務を当社は負わないものとします。かかる事項に関するお問い合わせは主催者へ直接ご連絡ください。
          </p>
          <p>
            4.課金対象となるコミュニティ活動が何らかの理由により継続が不可能となった場合、当社は会費・支援金等の参加者への返済義務を負わないものとします。かかる事項に関するお問い合わせは主催者へ直接ご連絡ください。
          </p>
        </section>

        <hr />

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            主催者向け個別規定
          </h4>
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 1 条（サービスの利用申し込み）
          </h4>
          <p>
            1.主催者規定は、当社が別途規定する利用規約に付随して、会員がイベント情報の登録及びチケットの発行を行うにあたり、会員と当社との本サービスの利用及び運営等にかかる一切の事項に適用されるものとし、会員は主催者規定及び当社が別途規定する参加者向け個別規定（以下、「参加者規定」といいます。）を確認及び承諾の上、本サービスを利用するものとします。当社は、会員が本サービスを利用した時点で、会員が本規約等の全ての記載内容に同意したものとみなし、当社及び会員の間に、本規約等に基づいて本サービスの利用に係る契約が成立したものとみなします。主催者規定に別途定義される用語を除き、主催者規定において用いられる用語は、本規約において定義される用語と同一の意味を有するものとします。
          </p>
          <p>
            2.当社は、会員の承諾を得ることなく主催者規定を変更することができるものとします。変更後の主催者規定は、本サイト上で表示された時点より効力を生じるものとし、会員が主催者規定の変更の効力が生じた後に本サービスを利用する場合には、変更後の主催者規定の全ての記載内容に同意したものとみなされます。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 2 条（個人情報の取扱い）
          </h4>
          <p>
            1.主催者が、チケット及び会費・支援金サービスを販売、利用又は提供するにあたって、本サイトを通じて個人情報を取得する場合は、個人情報保護法が定める個人情報取扱事業者としての義務等を遵守しなければならないものとします。また、主催者が、チケット及び会費・支援金サービスを販売又は提供するにあたって、参加者との間で別途合意を行う場合、自己の責任においてこれを行うものとし、当社は、当該合意について、何ら責任を負わないものとします。主催者は、本規約等と矛盾又は抵触等する合意を参加者との間で結ぶことはできないものとします。
          </p>
          <p>
            2.主催者は、当社が、主催者に対し、本規約第16条第2項第(2)号の規定又はプライバシーポリシー4.2.①又は②に基づき、当該主催者が主催するイベントに参加する参加者の氏名及び電子メールアドレスを提供した場合には、かかる氏名及び電子メールアドレスを、当該イベントにおける参加者の管理その他当該イベントに必要な範囲に限って使用するものとします。
          </p>
          <p>
            3.主催者がその主催するイベントに必要な範囲を超えて当該イベントの事前又は事後に当該イベントへの参加者に連絡を取ることを希望する場合には、主催者は、その利用目的を開示した上で、主催者が当該イベントに係るイベントページにおいて作成することのできる参加者に対するアンケートフォームを通じて、参加者から、電子メールアドレス、住所、電話番号その他主催者が必要と認める個人情報を取得するものとし、当社から提供を受けた氏名及び電子メールアドレスを、かかる目的のために利用しないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 3 条（イベント及びチケットの提供）
          </h4>
          <p>
            主催者は、本サービスを通じて作成したイベント及びチケットの内容に従い、参加者に対し、自らの責任で当該イベントを提供するものとします。また、参加者に提供するイベントに瑕疵があった場合や、瑕疵により参加者からのクレーム等が生じた場合は、主催者は、自己の責任と費用で参加者に誠実に対応し、当社に一切の迷惑をかけないものとします。但し、当社は、当社の判断により、主催者に対する事前の通知なく、参加者からのクレーム等に対し、主催者に代わり対応できるものとします。なお、当社は、当該対応に要した費用を主催者に請求することができるものとし、主催者は、これを直ちに補償することにつき予め承諾するものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 4 条（イベント提供時の表示）
          </h4>
          <p>
            主催者は、本サービスを通じて作成したイベントを参加者に対して提供するにあたり、参加者に対し、以下の事項を明示しなければならないものとします。
          </p>
          <p>
            1.主催者は、当社の決済プラットフォーム及び商号を用いて、有料イベントの参加者に対して、有料チケットの通信販売を行う者である旨。
          </p>
          <p>
            2.当該通信販売を行うにあたって利用されるクレジットカードの決済の対象となるものは、当社と参加者との間に発生する当社の参加者に対する立替払い債権であり、主催者と参加者との間の代金債権ではないこと。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 5 条（問い合わせ対応）
          </h4>
          <p>
            1.主催者は、本サイト及び本サービス上で登録した情報に関連し、当社、会員又は第三者から問い合わせがあった場合には、これに対し、速やかに対応をするものとします。
          </p>
          <p>
            2.当社、会員又は第三者からの問い合わせに対し、主催者が対応を怠たり、本サービスの運営に支障が及ぶと当社が判断した場合には、主催者の意向に関わらず、当社が該当問い合わせについて対応できるものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 6 条（イベントの審査・停止）
          </h4>
          <p>
            主催者が無料チケットの申込受付、及び有料チケットの販売受付を伴うイベントを作成した場合、当社は本規約等で定められた基準を基にイベント内容の審査を行います。当社は、特定のイベントが次のいずれかに該当すると判断した場合には、事前に通知することなく当該会員による本サービスの利用停止、当該会員のユーザー名及びパスワードの変更、当該会員の会員資格の取消し、又は当該イベントの停止及び削除を行えるものとします。これにより会員に何らかの損害が生じたとしても、当社は一切の責任を負わないものとします。
          </p>
          <p>1.法令、本規約等に違反するものである場合</p>
          <p>
            2.本サービスの利用に関する不正行為に基づき作成されたものである場合
          </p>
          <p>3.特定の思想・宗教への勧誘などを目的とするものである場合</p>
          <p>
            4.性行為、わいせつな行為、面識の無い異性との出会い等を目的とするなど、公序良俗に反する内容のものである場合
          </p>
          <p>
            5.登録情報に虚偽の事実又は不正確な情報が含まれているものである場合
          </p>
          <p>
            6.当社にサービスを提供する会員及びその他第三者の権利、名誉等を損ねるものである場合
          </p>
          <p>
            7.有害なコンピュータープログラム、メール等を送信又は書き込むものである場合
          </p>
          <p>
            8.当社から事前の許可を得ることなく、本サイト及び本サービス上で提供される情報の一部又は全部を複製、複写、送信、転載、配布、頒布等の方法により、第三者に提供するものである場合
          </p>
          <p>
            9.当社又は第三者の著作権、商標権等の知的財産権を侵害する行為を含むものである場合
          </p>
          <p>
            10.前項に定めるほか、当社又は第三者の財産権、プライバシー権、肖像権、その他の権利を侵害する行為を含むものである場合
          </p>
          <p>
            11.本サービスの機能や情報の正確性に関する問い合わせ又はクレームを投稿する行為を含むものである場合
          </p>
          <p>
            12.当社が意図する本サービスの目的以外で本サービスを利用するものである場合
          </p>
          <p>13.当社又は第三者に対する迷惑行為を含むものである場合</p>
          <p>
            14.詐欺、規制薬物の濫用、売買春、マネーロンダリング等の犯罪に結びつく、又は結びつくおそれのあるものである場合
          </p>
          <p>
            15.サイト外取引についての優遇措置の表示、その他の方法により顧客を本サービス外の取引に誘引する行為を含むものである場合
          </p>
          <p>16.その他当社が不適切と判断した場合</p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 7 条（イベントの中止・キャンセル）
          </h4>
          <p>
            主催者が、本サービス上にて公開したイベントを、その終了前にやむを得ず中止する場合、当社所定の方法により画面の指示に従って当該イベントのキャンセル手続きを行ってください。当該イベントのキャンセル手続きを行った場合、イベントの中止を通知するメールが、当該イベントに係るチケットを購入又は取得済みの会員に自動配信され、当該チケットは無効となります。また、有料チケットの販売を含むイベントが主催者の事情により中止となり、主催者が当社所定の方法でイベントのキャンセル手続きを行った場合、当社が定める返金手数料については、その全額を主催者が負担するものとし、有料チケットを購入した会員に対しては、購入代金の全額を当社より返金いたします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 8 条（インターネット接続）
          </h4>
          <p>
            本サービスにて購入又は取得されたチケットについて、本サイト上で受付確認作業を行うには、インターネットに接続された状態のパーソナルコンピューター又はインターネットに接続可能な対応端末が必要です。パーソナルコンピューター又は対応端末がインターネットに接続できる環境の確保は、主催者の費用と責任で行うものとします。また、通信回線やコンピュータ、サーバなどの障害により、本サイトでの受付確認作業に支障が発生した場合であっても、当社は一切の責任を負わないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 9 条（チケット販売代金の払い出し）
          </h4>
          <p>
            1.主催者が参加者に対し有料チケットの内容に基づくイベントを提供し、当社がそれを確認した後、5営業日以内に、当社は、チケットの販売代金から当社所定の決済処理費用を差し引いた金額（以下「支払金額」といいます。）を、主催者が本サイト上で指定した銀行口座へ支払います。なお、当該支払いに要する送金手数料は、主催者が負担するものとします。また、主催者が本サイト上で指定した銀行口座情報の誤りにより当該支払いを行うことができず、再度支払いを要する場合には、当該支払いに要する送金手数料とは別に組戻し手数料を主催者が負担するものとします。
          </p>
          <p>
            2.本サイトにおいて、主催者が支払先に関する情報を登録していない場合は、当該情報の登録を当社が確認するまで、支払いを行いません。また、主催者が本サイト上で登録した支払先に関する情報に誤りがあり、それにより支払金額の受取が遅延した場合や損害が発生した場合であっても、当社は一切責任を負わないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 10 条（イベント集客サービス）
          </h4>
          <p>
            当社は、本サイトを通じて作成されたイベントの集客をサポートするイベント集客サービス（以下、「集客サービス」といいます。）を提供しています。集客サービスは、本サイトの会員に対し、電子メールの送信、SNSへの掲載などを通じて、主催者が本サイト上で開催するイベントを当社が告知するサービスです。集客サービスの利用に関しては、以下に定める事項が適用されるものとします。
          </p>
          <p>
            1.集客サービスの利用を希望する主催者は、当社所定の方法で事前に当社に対し申し込みを行うものとします。
          </p>
          <p>
            2.当社の裁量で、当該イベントに集客サービスの利用を許可するか否かを決定するものとし、当社に許可されたイベントのみが集客サービスを利用できるものとします。
          </p>
          <p>
            3.当社によって集客サービスの利用が許可されたイベントに係る集客サービスの具体的な内容及び条件並びに集客サービスの利用に係る費用は、当社が、当該イベントの主催者に対し提示するものとし、当該イベントの主催者は、これに合意するものとします。
          </p>
          <p>
            4.前項に従って主催者と当社が合意した内容に基づき、当社は、他の会員に対する電子メールの配信、本サイトへの掲載及びSNSを通じて、集客サービスの対象となるイベントを告知するものとします。
          </p>
          <p>
            5.集客サービスに関して、当社が集客サービスの利用を希望する主催者に対し書面、口頭、本サイトその他一切の方法を通じて示す集客サービスに係る数字、目安、効果、実績、成果その他の事項は、参考情報として示されたものに過ぎず、当社は、集客サービスの利用を希望する主催者に対し、集客サービスを利用することでこれらの事項が達成できることを、なんら保証するものではありません。集客サービスの利用を希望する主催者は、この点を認識した上で集客サービスを利用するものとし、当社に対し、集客サービスを利用した結果について、不満、不平、クレーム、苦情その他一切の異議の申し立てを行えないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 11 条（参加者特典の配布）
          </h4>
          <p>
            当社は、イベントの参加者に対し、当社や第三者の企業及び店舗等が提供する特典及び広告（以下、「参加者特典」といいます。）を配信及び掲載することがあります。参加者特典に関しては、以下に定める事項が適用されるものとします。
          </p>
          <p>
            1.参加者特典は、参加者に対する電子メール及び本サイト上で掲載するものとします。
          </p>
          <p>
            2.参加者特典は、当該イベントの主催者に事前の告知なく、当社が適切だと判断したものを配信及び掲載します。
          </p>
          <p>
            3.参加者特典は、当社の判断で配信及び掲載を中止できるものとします。
          </p>
          <p>
            4.当該イベントの主催者は、配信及び掲載された参加者特典について、不満、不平、クレーム、苦情その他一切の意義申し立てを行えないものとします。
          </p>
          <p>
            5.第三者の企業及び店舗等が提供する参加者特典の配信及び掲載により、主催者又は第三者に損害が発生した場合でも、当社は一切の責任を負いません。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 12 条（会費・支援金サービス）
          </h4>
          <p>
            本サービスでは、主催者がイベント開催の有無に関わらず、コミュニティの形成と発展を目的として参加会員より月額あるいは年額の会費、または活動継続を目的とした支援金を募ることができます。これらの会費あるいは支援金は当社が当該手数料を差し引いた上で主催者へ送金いたします。会費・支援金サービスに関しては、以下に定める事項が適用されるものとします。
          </p>
          <p>
            1.本サービスを利用する場合は、本規約等のほかに、主催者が指定する会則あるいは支援金の使用用途などを明記した規約も参加者へ提示し、参加者からの同意を得ることを必要とするものとします
          </p>
          <p>
            2.本サービス継続利用中に集められた会費・支援金等は、当社が当該月末締め翌月月初払いで、当社が指定する手数料を差し引いた上でご指定の銀行口座に振り込むこととします。
          </p>
          <p>
            3.会費・支援金の額、返金、使用目的などの方針・取り決めは各主催者が判断し、当社はかかる事項に関して一切責任を負わないものとします。
          </p>
          <p>
            4.会費・支援金の支払いへの見返りとして主催者より提示されたサービスの内容に関して当社は一切責任を負わないものとします。かかる事項に関するユーザーからのお問い合わせに対しては主催者が直接対処するものとし、あらゆる障害や係争から当社は免責されるものとします。
          </p>
          <p>
            5.課金対象となるコミュニティ活動が何らかの理由により継続が不可能となった場合、当社は会費・支援金等の参加者への返済義務を負わないものとします。また、会費・支援金等の課金に際して当社に支払われた手数料も一切返金しないものとします。
          </p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 13 条（主催者の表明及び保証）
          </h4>
          <p>
            1.主催者は、当社に対し、主催者（主催者の役員及び従業員を含みます。）が、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等その他これらに準ずる者
            (以下これらを「暴力団員等」といいます)
            又は以下の各号のいずれにも該当しないことを、表明し、かつ、保証するとともに、将来においても、主催者がこれらのいずれにも該当しないこと、及び、自ら又は第三者を利用して第2項各号のいずれかに該当する行為を一切行わないことを、確約するものとします。
          </p>
          <p>
            また、主催者の故意過失を問わず、主催者がかかる表明及び保証に違反し、あるいは、かかる確約に違反した場合には、主催者は、(1)当社が主催者のイベントページを当社のサイトおよびサーバから削除すること、また、(2)当社が直ちに本規約等に基づく当社と主催者間の契約を解除し、主催者の会員資格を取り消すことについて、異議なく承諾するものとします。当社によるこれらの措置により主催者に何らかの損害が生じた場合でも、主催者は、当社に対し、何らの請求も行えないものとし、主催者においてその損害の一切を負担するものとします。また、かかる表明及び保証又は確約に違反して当社（当社の役員及び従業員を含みます）又は参加者（参加者の役員及び従業員を含みます）に何らかの損害が生じた場合には、主催者(ただし、主催者の役員及び従業員は含まないものとします)は、その一切の損害を賠償しなければならないものとします。
          </p>
          <p>(1).暴力団員等が経営を支配していると認められる関係を有すること</p>
          <p>
            (2).暴力団員等が経営に実質的に関与していると認められる関係を有すること
          </p>
          <p>
            (3).自己、自社もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること
          </p>
          <p>
            (4).暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること
          </p>
          <p>
            (5).役員または経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること
          </p>
          <p>
            2.主催者は、当社に対し、自ら又は第三者を利用して次の各号に該当する行為を行わないことを確約するものとします。
          </p>
          <p>(1).暴力的な要求行為</p>
          <p>(2).法的な責任の範囲を超えた不当な要求行為</p>
          <p>(3).取引に関して、脅迫的な言動をし、又は暴力を用いる行為</p>
          <p>
            (4).風説を流布し、偽計を用い若しくは威力を用いて当社の信用を毀損し、又は当社の業務を妨害する行為
          </p>
          <p>(5).その他前各号に準ずる行為</p>
        </section>

        <section className="mb-10">
          <h4 className="mb-4 text-base font-semibold text-neutral-900">
            第 14 条（主催者によるサービスの利用の停止等）
          </h4>
          <p>
            当社は、主催者が以下のいずれかの事由に該当する場合、又は、提携金融機関の要請があった場合には、主催者が当社のプラットフォームを通して参加者に提供しているイベントページの削除、本サービスの利用の停止その他必要な措置（法的措置を含みます）を取ることができるものとします。この場合において、主催者は、速やかに当社の指示に従い、改善措置をとらなければならないものとします。
          </p>
          <p>
            1.主催者が本規約等のいずれかに違反したとき（主催者が本規約第13条各項のいずれかに該当した場合を含みます）。
          </p>
          <p>
            2.主催者の有料チケットを購入した参加者から、主催者に対し、有料チケットに係るイベントの開催中止及び延期又は有料チケットの返金等に関する苦情が頻発したとき。
          </p>
          <p>
            3.その他当社が消費者保護の観点等からサービスの利用の停止等の措置が必要と判断したとき。
          </p>
        </section>

        <section className="mb-10">
          <p>更新日：平成30年4月1日</p>
          <p>株式会社エムセック</p>
        </section>
      </div>
    </div>
  </main>
);
